import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";
const config = {
  BASE_URL: "https://admin.thezeeshangroup.com/",
};

const AboutUs = () => {
  const [getaboutData, setGetaboutData] = useState([]);
  const [loader, setLoader] = useState(true);
  const aboutpageApi = async () => {
    try {
      const res = await apiClient.get(`api/aboutpages`);
      setGetaboutData(res.data);
      setLoader(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    aboutpageApi();
  }, []);
  return (
    <>
      <div>
        {loader ? (
          <div className="d-flex justify-content-center">
            <LineWave
              height="250"
              width="150"
              color="#56b13d"
              ariaLabel="line-wave"
            />
          </div>
        ) : (
          getaboutData && (
            <div>
              <div className="title-bar-wrapper">
                <Container>
                  <Row>
                    <div className="title">
                      <h1>About Us</h1>
                    </div>
                    <ul className="bread-crumb pull-right">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>-</li>
                      <li>About Us</li>
                    </ul>
                  </Row>
                </Container>
              </div>
              <div className="service-section challenges">
                <Container>

                  <Row>
                    <Col lg="6" md="12">
                      <div className="img-box">
                        <img src={`${config.BASE_URL}uploads/${getaboutData.about?.about_image}`} alt="About Image" />
                      </div>
                    </Col>
                    <Col lg="6" md="12">
                      <div className="pbmit-heading-subheading">
                        <h4 className="pbmit-subtitle">About Us</h4>
                        <h2 className="pbmit-title">{getaboutData.about?.title}</h2>
                      </div>
                      <div className="challenges-content mt-3" dangerouslySetInnerHTML={{ __html: getaboutData.about?.about_desc }} />
                      {/* <p>
                          {getaboutData.about?.about_desc}
                        </p>
                      </div> */}
                    </Col>
                  </Row>

                </Container>
              </div>
              <div className="buy-us corporate-bg">
                <Container>
                  <Row>
                    <Col sm="12">
                      <h2>Corporate Office</h2>
                      <p>
                        {getaboutData.about?.corporat_office_title}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="7" md="12">
                      <div className="corporate-content mt-3" dangerouslySetInnerHTML={{ __html: getaboutData.about?.corporat_office_desc }} />
                    </Col>
                    <Col lg="5" md="12">
                      <div className="corporate-img">
                        <img src={`${config.BASE_URL}uploads/${getaboutData.about?.corporat_office_image}`} alt="corporat office image" />
                      </div>
                    </Col>
                  </Row>
                </Container>
                <div className="mission-area">
                  <Container>
                    <Row>
                      <Col lg="6" md="12">
                        <div className="thumb">
                          <div className="thumb-1">
                            <img
                              src={`${config.BASE_URL}uploads/${getaboutData.about?.our_mission_image1}`}
                              alt="our mission image1"
                            />
                          </div>
                          {/* <div className="thumb-2">
                            <img
                              src={`${config.BASE_URL}uploads/${getaboutData.about?.our_mission_image2}`}
                              alt="our mission image2"
                            />
                          </div> */}
                        </div>
                      </Col>
                      <Col lg="6" md="12">
                        <div className="our-mission">
                          <div className="pbmit-heading-subheading">
                            <h4 className="pbmit-subtitle">OUR MISSION</h4>
                            <h2 className="pbmit-title text-left">
                              {getaboutData.about?.our_mission_title}
                            </h2>
                          </div>
                          <div className="challenges-content mt-3" dangerouslySetInnerHTML={{ __html: getaboutData.about?.our_mission_desc }} />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Container>
                  <Row>
                    <Col lg="7" md="12">
                      <div className="our-mission">
                        <div className="pbmit-heading-subheading">
                          <h4 className="pbmit-subtitle">OUR Vision</h4>
                          <h2 className="pbmit-title text-left">
                            {getaboutData.about?.our_vision_title}
                          </h2>
                        </div>
                        <div className="corporate-content mt-3" dangerouslySetInnerHTML={{ __html: getaboutData.about?.our_vision_desc }} />
                      </div>
                    </Col>
                    <Col lg="5" md="12">
                      <div className="corporate-img">
                        <img
                          src={`${config.BASE_URL}uploads/${getaboutData.about?.our_vision_image1}`}
                          alt="our vision image"
                        />
                      </div>
                    </Col>
                  </Row>
                </Container>
                <div className="mission-area">
                  <Container>
                    <Row>
                      <Col lg="6" md="12">
                        <div className="our-mission">
                          <div className="pbmit-heading-subheading">
                            <h4 className="pbmit-subtitle">OUR VALUES</h4>
                            {/* <h2 className="pbmit-title text-left">
                      We believe that we can save more lifes with you.
                    </h2> */}
                          </div>
                          <div className="challenges-content mt-3" dangerouslySetInnerHTML={{ __html: getaboutData.about?.our_values_desc }} />
                        </div>
                      </Col>
                      <Col lg="6" md="12">
                        <div className="thumb">
                          <div className="thumb-1">
                            <img
                              src={`${config.BASE_URL}uploads/${getaboutData.about?.our_values_image1}`}
                              alt="our values image 1"
                            />
                          </div>
                          {/* <div className="thumb-2">
                            <img
                              src={`${config.BASE_URL}uploads/${getaboutData.about?.our_values_image2}`}
                              alt="our values image 2"
                            />
                          </div> */}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
              {getaboutData?.certificates?.length > 0 && (
                <div className="buy-us certification-bg">
                  <Container>
                    <Row>
                      <Col sm="12">
                        <h2>Certificates</h2>
                        <p>
                          {getaboutData.about?.certificates_title}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      {getaboutData?.certificates?.map((certificate, i) => {
                        return (
                          <Col lg="3" md="3" sm="6">
                            <div className="certificate-main">
                              <div className="certificate-img">
                                <img
                                  src={`${config.BASE_URL}uploads/certificates/${certificate.file}`}
                                  alt={certificate.name}
                                />
                              </div>
                              <div className="certificate-content">
                                <h4>{certificate.name}</h4>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </Container>
                </div>
              )}

              <div className="construction-team chairman-bg" id="chairman&md">
                <div className="container">
                  <div className="row">
                    <div className="col-md-4 align-self-center">
                      <div className="text-center">
                        <div className="team-img">
                          <img
                            src={`${config.BASE_URL}uploads/${getaboutData.about?.about_md_profile_image}`}
                            alt={getaboutData.about?.about_md_name}
                          />
                        </div>
                        <h4 className="mb-1">{getaboutData.about?.about_md_name}</h4>
                        <p>{getaboutData.about?.about_md_designation}</p>
                      </div>
                    </div>
                    <div className="col-md-8 align-self-center">
                      <div className="chairman-content">
                        <p>
                          {getaboutData.about?.about_md_details}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="construction-team chairman-bg bg-white" id="operation-head">
                <div className="container">
                  <div className="row">
                    <div className="col-md-8 align-self-center">
                      <div className="chairman-content">
                        <p>
                          {getaboutData.about?.about_ohead_details}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4 align-self-center">
                      <div className="text-center">
                        <div className="team-img">
                          <img
                            src={`${config.BASE_URL}uploads/${getaboutData.about?.about_ohead_profile_image}`}
                            alt={getaboutData.about?.about_ohead_name}
                          />
                        </div>
                        <h4 className="mb-1">{getaboutData.about?.about_ohead_name}</h4>
                        <p>{getaboutData.about?.about_ohead_designation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="construction-team chairman-bg" id="ceo">
                <div className="container">
                  <div className="row">
                    <div className="col-md-4 align-self-center">
                      <div className="text-center">
                        <div className="team-img">
                          <img
                            src={`${config.BASE_URL}uploads/${getaboutData.about?.about_ceo_profile_image}`}
                            alt={getaboutData.about?.about_ceo_name}
                          />
                        </div>
                        <h4 className="mb-1">{getaboutData.about?.about_ceo_name}</h4>
                        <p>{getaboutData.about?.about_ceo_designation}</p>
                      </div>
                    </div>
                    <div className="col-md-8 align-self-center">
                      <div className="chairman-content">
                        <p>
                          {getaboutData.about?.about_ceo_details}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="construction-team chairman-bg bg-white" id="construction-incharge">
                <div className="container">
                  <div className="row">
                    <div className="col-md-8 align-self-center">
                      <div className="chairman-content">
                        <p>
                          {getaboutData.about?.construction_incharge_details}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4 align-self-center">
                      <div className="text-center">
                        <div className="team-img">
                          <img
                            src={`${config.BASE_URL}uploads/${getaboutData.about?.construction_incharge_profile_image}`}
                            alt={getaboutData.about?.construction_incharge_name}
                          />
                        </div>
                        <h4 className="mb-1">{getaboutData.about?.construction_incharge_name}</h4>
                        <p>{getaboutData.about?.construction_incharge_designation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {getaboutData?.members?.length > 0 && (
                <div className="construction-team" id="construction-incgarge">
                  <div className="container">
                    <div className="row">
                      {getaboutData?.members?.map((member, j) => {
                        return (
                          <div className="col-sm-6 col-lg-3">
                            <div className="text-center">
                              <div className="team-img">
                                <img
                                  src={`${config.BASE_URL}uploads/member/${member.profile_image}`}
                                  alt={member.name}
                                />
                              </div>
                              <h4 className="mb-1">{member.name}</h4>
                              <p>{member.designation}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

            </div>
          )
        )}
      </div>
    </>

  );
};

export default AboutUs;
